import React, { memo } from 'react'
import CommonDialog from '../../../../../common/components/dialog/CommonDialog'
import styles from './teammember.module.scss'
import { useDispatch } from 'react-redux'
import { showLoader, hideLoader } from '../../../../../stores/slices/loader-slice'
import { toast } from 'react-toastify'
import { getErrorMessage } from '../../../../../utils/error-handler'
import { UtilityTeamMember } from '../../../../../model/utility-users/utility-team-member'
import { useDeleteTeamMemberMutation } from '../../../../../service/utility-users-service'
import Button from '../../../../../common/components/xepp/button/Button'

type Props = {
    user: UtilityTeamMember
    onCloseDialog: () => void
    onTeamMemberDelete: () => void
}

const DeleteTeamMemberDialog: React.FC<Props> = memo((props: Props) => {
    const dispatch = useDispatch();
    const [deleteTeamMember, { isLoading }] = useDeleteTeamMemberMutation();
    const handleDeleteTeamMember = async () => {
        
        try {
            dispatch(showLoader());
            await deleteTeamMember(props.user!.id).unwrap();
            props.onTeamMemberDelete();
            toast.success(`User ${props.user!.email} deleted successfully`)
        } catch (error: any) {
            toast.error(getErrorMessage(error.data) ?? 'An Error occurred');
            
        } finally {
            dispatch(hideLoader());
            props.onCloseDialog();
        }
    }

    const cancel = () => {
        props.onCloseDialog();
    }

    return (
        <CommonDialog onCloseDialog={props.onCloseDialog}>
            <div className={`${styles.container} ${styles.DialogContainer}`}>
                <div className={styles.DialogTitle}>
                    Delete Team Member
                    <div className={styles.description}>
                        This action cannot be undone.
                    </div>
                </div>
                <div className={styles.DialogBody}>
                    Are you sure you want to delete team member?
                </div>
                <div className={styles.DialogContainerButtons}>
                    <Button text={'No'} variant={`outline`} onClick={cancel} />
                    <Button text={'Yes'}  disabled={isLoading} onClick={handleDeleteTeamMember} />
                </div>
            </div>
        </CommonDialog>
    )
})

export default DeleteTeamMemberDialog